import { render, staticRenderFns } from "./categories-select.vue?vue&type=template&id=ab2c7fb2&scoped=true"
import script from "./categories-select.vue?vue&type=script&lang=js"
export * from "./categories-select.vue?vue&type=script&lang=js"
import style0 from "@jledentu/vue-finder/dist/vue-finder.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./categories-select.vue?vue&type=style&index=1&id=ab2c7fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2c7fb2",
  null
  
)

export default component.exports